<template>
  <div style="display:contents;">
    <TransactionListTemplate
      :screenConfig="setScreenConfig"
      :rowClick="rowClickCallBack"
      :setLoading="setLoading"
      :persistenceKey="'sales-order-list'"
      :loadDataGrid="loaded"
      :gcPopupConfig="gcPopupConfig"
      :gcSOPayNowPopupConfig="gcSOPayNowPopupConfig"
      :gcSOPartPickPopupConfig="gcSOPartPickPopupConfig"
      :gcPopupDepositClaimConfig="gcPopupDepositClaimConfig"
      ref="sales-order-list"
      v-if="loaded"
    />
    <gc-popup-sales-order-split
      v-if="splitOrderCode"
      :sales-order-code="splitOrderCode"
      :visible="splitOrderVisible"
      @update:visible="splitOrderVisible = $event"
      @saved="onSplitOrderSaved"
    />
  </div>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import { CommonStorage, FeatureStorage } from "../../_services/storage";
import { DespatchOrderListService } from "../../_services/api/sales/despatch-order-list.service";
import { SalesOrderListService } from "../../_services/api/sales/sales-order-list.service";
import { CacheService } from "../../_services/cache/cache-service";
import SettingsService from "../../_services/api/settings/graycorp/settings.service";
import {
  SalesOrderTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/sales/salesorder-tabs";
import { SalesOrderService } from "../../_services/api/sales/sales-order.service";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";

function logDev() {
  // eslint-disable-next-line no-console
  console.log("CX LOG >>> ", arguments);
}

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
    GcPopupSalesOrderSplit: () => import("@/popups/sales/gc-popup-sales-order-split.vue"),
  },
  data() {
    return {
      setLoading: false,
      CustomerSalesRepresentativeCode: undefined,
      loaded: false,
      splitOrderVisible: false,
      splitOrderCode: null,
      SalesOrderScreenVersion: "V1",
      gcPopupVisible: false,
      adjustShipDateDataModel: {
        SalesOrder: undefined,
        Customer: undefined,
        ShipDate: undefined,
        RequiredByDate: undefined,
        NewShipDate: undefined,
      },
      NewShipDate: {
        Min: undefined,
        Value: undefined,
      },
      payNowPopupProps: {
        visible: false,
        salesOrderCode: undefined,
        customerCode: undefined,
        customerName: undefined,
        orderAmount: undefined,
        callback: () => {},
      },
      partPickPopupProps: {
        visible: false,
        salesOrderCode: undefined,
        customerName: undefined,
        customerCode: undefined,
        shipDate: undefined,
        requiredByDate: undefined,
        callback: () => {},
      },
      depositClaimProps: {
        visible: false,
        callback: () => {},
      },
    };
  },
  computed: {
    gcSOPayNowPopupConfig() {
      return this.payNowPopupProps;
    },
    gcSOPartPickPopupConfig() {
      return this.partPickPopupProps;
    },
    gcPopupDepositClaimConfig() {
      return this.depositClaimProps;
    },
    gcPopupConfig() {
      return {
        title: `Adjust SO Dates for SO #${this.adjustShipDateDataModel.SalesOrder}`,
        dataModel: this.adjustShipDateDataModel,
        callback: this.adjustShipDateCallback,
        callBack: this.adjustShipDateCallback,
        gcPopupVisible: this.gcPopupVisible,
        height: 275,
        formOptions: {
          gcLabelLocation: "left",
        },
        items: [
          {
            dataField: "SalesOrder",
            label: {
              text: "Sales Order #",
            },
            editorOptions: {
              readOnly: true,
            },
          },
          {
            dataField: "Customer",
            label: {
              text: "Customer",
            },
            editorOptions: {
              readOnly: true,
            },
          },
          {
            screenField: "ShipDate",
            dataField: "RequiredByDate",

            label: {
              text: "Required By Date",
            },
            editorOptions: {
              readOnly: true,
            },
          },
          {
            screenField: "ShipDate",
            dataField: "ShipDate",
            label: {
              text: "Current Ship Date",
            },
            editorOptions: {
              readOnly: true,
            },
          },
          {
            screenField: "ShipDate",
            dataField: "NewShipDate",
            label: {
              text: "New Ship Date",
            },
            editorOptions: {
              min: this.NewShipDate.Min,
              allowUpdate: true,
              onValueChanged: (e) => {
                if (e.event) this.onChangeNewShipDate(e);
              },
            },
          },
        ],
        save: {
          text: "Update",
          clickCallback: (e) => {
            this.onGcPopUpUpdate(e);
          },
          disabled: this.allowPopupUpdate,
        },
        back: {
          text: "Cancel",
          clickCallback: () => {
            this.adjustShipDateCallback();
          },
        },
      };
    },
    allowPopupUpdate() {
      if (
        this.NewShipDate.Value != undefined &&
        this.adjustShipDateDataModel.ShipDate != undefined
      ) {
        let time1 = this.NewShipDate.Value.getTime();
        let time2 = this.adjustShipDateDataModel.ShipDate.getTime();
        return time1 == time2;
      } else {
        return true;
      }
    },
    salesOrderCreateRoute() {
      var touchSO = CommonStorage.getItems("TouchSalesOrder");
      if (this.isTablet && touchSO == "Y") return "/t-sales-order/create";
      else if (this.SalesOrderScreenVersion == "V2")
        return "/sales-order-v2/create";
      else if (this.SalesOrderScreenVersion == "V3")
        return "/sales-order-v3/create";
      else if (this.SalesOrderScreenVersion == "V4") {
        return "/sales-order-v4/create";
      } else if (this.SalesOrderScreenVersion == "V5") {
        return "/sales-order-v5/create";
      } else {
        return "/sales-order/create";
      }
    },
    salesOrderRouteForRowClick() {
      var touchSO = CommonStorage.getItems("TouchSalesOrder");
      if (this.isTablet && touchSO == "Y") return "t-sales-order";
      else if (this.SalesOrderScreenVersion == "V2") {
        return "sales-order-v2";
      } else if (this.SalesOrderScreenVersion == "V3") return "sales-order-v3";
      else if (this.SalesOrderScreenVersion == "V4") return "sales-order-v4";
      else if (this.SalesOrderScreenVersion == "V5") return "sales-order-v5";
      else {
        return "sales-order";
      }
    },
    setScreenConfig() {
      var config = {
        title: "Sales Orders",
        ScreenName: "Sales Orders - All",
        selectedIndex: GetIndexByTabName("All"),
        tabs: SalesOrderTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "SalesOrderList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              select: [
                "CodeComputedString",
                "Code",
                "CustomerCode",
                "CustomerName",
                "BranchCode",
                "BranchDescription",
                "OrderNo",
                "CustomerSalesContractName",
                "CustomerSalesContractCode",
                "SalesRepresentativeFullName",
                "SalesRepresentativeCode",
                "CustomerSalesRepresentativeCode",
                "CustomerSalesRepresentativeFullName",
                "DateIn",
                "ShipDate",
                "RequiredByDate",
                "DeliveryAddressCompanyName",
                "SalesOrderTypeCode",
                "SalesOrderTypeDescription",
                "FriendlyStatus",
                "InvoiceFriendlyStatus",
                "DateCreated",
                "Status",
                "Invoice",
                "FxTotal",
                "CurrencyCode", // Deposit Clain Popup
                "HasLinkedWorkOrder",
              ],
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Orders",
                message: "Get Started, Add an Order",
              },
            },
          },
          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: this.salesOrderCreateRoute,
                clickAction: {},
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission("SalesOrder", "create"),
              },
            ],
            filterOnEnter: true,
          },
          columns: [
            {
              screenField: "SalesOrder",
              gridDataField: "CodeComputedString", // CodeComputedString
              dataField: "CodeComputedString", // CodeComputedString
              calculateSortValue: "Code",
              sortOrder: "desc",
              sortIndex: 0,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              width: ColumnWidth.SalesOrderCode.width,
              maxWidth: ColumnWidth.SalesOrderCode.minWidth,
            },
            {
              screenField: "Code",
              filterLabel: "Sales Order",
              showInColumnChooser: false,
              visible: false,
              type: "Integer",
              filterIndex: 0,
              width: ColumnWidth.SalesOrderCode.width,
              maxWidth: ColumnWidth.SalesOrderCode.minWidth,
            },
            {
              screenField: "Customer",
              filterIndex: 4,
            },
            {
              screenField: "Branch",
              filterIndex: 5,
              visible: false,
            },
            {
              screenField: "CustPO",
              gridDataField: "OrderNo",
              filterDataField: "OrderNo",
              dataType: "string",
              type: "Text",
              filterIndex: 1,
              width: ColumnWidth.CustPO.width,
              maxWidth: ColumnWidth.CustPO.minWidth,
            },
            {
              screenField: "Contract",
              gridDataField: "CustomerSalesContractName",
              visible: FeatureStorage.checkPermission(
                "CustomerSalesContract",
                this.baseView.mode
              ),
              showInColumnChooser: FeatureStorage.checkPermission(
                "CustomerSalesContract",
                this.baseView.mode
              ),
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "CustomerSalesContractName",
                  },
                ],
                secondary: [
                  {
                    dataField: "CustomerSalesContractCode",
                  },
                ],
              },
              dataSourceConfig: {
                endpoint: "api/CustomerSalesContractList",
                sort: {
                  selector: "CustomerSalesContractName",
                  asc: true,
                },
              },
              editorTemplate: {
                primary: [
                  {
                    dataField: "CustomerSalesContractName",
                  },
                ],
                secondary: [
                  {
                    dataField: "CustomerSalesContractCodeString",
                  },
                ],
              },
              valueExpr: "CustomerSalesContractCodeString",
              displayExpr: "CustomerSalesContractName",
              exportFields: [
                {
                  dataField: "CustomerSalesContractCode",
                  label: "Contract Code",
                },
                {
                  dataField: "CustomerSalesContractName",
                  label: "Contract Description",
                  allowSearch: false,
                },
              ],
              filterDataField: "CustomerSalesContractCode",
              filterIndex: 13,
              width: ColumnWidth.Contract.width,
              maxWidth: ColumnWidth.Contract.minWidth,
            },
            {
              screenField: "OrderRep",
              gridDataField: "SalesRepresentativeFullName",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "SalesRepresentativeFullName",
                  },
                ],
                secondary: [
                  {
                    dataField: "SalesRepresentativeCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "SalesRepresentativeCode",
                  label: "Order Rep Code",
                },
                {
                  dataField: "SalesRepresentativeFullName",
                  label: "Order Rep Full Name",
                  allowSearch: false,
                },
              ],
              filterDataField: "SalesRepresentativeCode",
              filterIndex: 11,
              width: ColumnWidth.OrderRep.width,
              maxWidth: ColumnWidth.OrderRep.minWidth,
            },
            {
              screenField: "CustomerRep",
              visible: false,
              filterIndex: 12,
              filterDefaultValue: this.getCustomerRepDefault,
            },
            {
              screenField: "DateIn",
              gridLabel: "Date In",
              filterLabel: "Date In",
              filterIndex: 7,
              width: ColumnWidth.Date.width,
              maxWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "ShipDate",
              gridLabel: "Ship Date",
              filterDataField: "ShipDate",
              filterIndex: 8,
              width: ColumnWidth.Date.width,
              maxWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "RequiredByDate",
              gridLabel: "Reqd Date",
              filterLabel: "Reqd Date",
              filterDataField: "RequiredByDate",
              filterIndex: 9,
              width: ColumnWidth.Date.width,
              maxWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "ProductAcct",
              visible: false,
              filterIndex: 10,
              filterOperator: "contains",
              gridDataField: "ItemCodeList",
              filterDataField: "ItemCodeList",
              showInColumnChooser: false,
            },
            {
              screenField: "DeliveryCompany",
              visible: false,
              gridLabel: "Delivery Company",
            },
            {
              screenField: "OrderType",
              filterIndex: 14,
              filterDataField: "SalesOrderTypeCode",
              filterLabel: "SO Type",
              cellTemplate: "",
              cellTemplateRecord: "",
              visible: false,
            },
            {
              screenField: "OrderStatus",
              gridDataField: "FriendlyStatus",
              filterDataField: "FriendlyStatus",
              filterIndex: 2,
              // filterDefaultValue: ["Active", "Draft", "Locked", "Pending"],
            },
            {
              screenField: "OrderStatus",
              gridDataField: "InvoiceFriendlyStatus",
              filterDataField: "InvoiceFriendlyStatus",
              filterIndex: 3,
              filterLabel: "Invoice Status",
              dataSourceConfig: {
                data: ["Invoiced", "Pending Invoice"],
              },
            },
            {
              screenField: "DateCreated",
              filterIndex: 6,
              visible: false,
              showInColumnChooser: false,
              filterOperator: ">",
              filterDefaultValue: new Date().addDays(-31),
            },
            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              width: 50,
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Lock Order",
                      data: data,
                      clickAction: this.lockOrder,
                      visible:
                        data.data.FriendlyStatus != "Locked" ? true : false,
                    },
                    {
                      menuText: "Unlock Order",
                      data: data,
                      clickAction: this.unLockOrder,
                      visible:
                        data.data.FriendlyStatus == "Locked" ? true : false,
                    },
                    {
                      menuText: `Adjust SO Dates`,
                      data: data,
                      clickAction: this.showAdjustShipDatePopup,
                      disabled: data.data.HasLinkedWorkOrder == "Y",
                      visible:
                        FeatureStorage.checkPermission(
                          "SalesOrder",
                          "create"
                        ) &&
                        data.data.Status != "X" &&
                        data.data.Status != "C",
                    },
                    {
                      menuText: `Complete Order`,
                      data: data,
                      clickAction: this.completeSalesOrder,
                      visible:
                        FeatureStorage.checkPermission(
                          "SalesOrder",
                          "create"
                        ) &&
                        data.data.Status == "A" &&
                        data.data.Invoice != 0,
                    },
                    {
                      menuText: `Pay Now`,
                      data: data,
                      clickAction: this.showPayNowSalesOrder,
                      visible:
                        (FeatureStorage.checkPermission(
                          "CashReceipt",
                          "read"
                        ) ||
                          FeatureStorage.checkPermission(
                            "CashReceipt",
                            "create"
                          )) &&
                        (data.data.Status == "A" || data.data.Status == "H"),
                      disabled: !FeatureStorage.checkPermission(
                        "CashReceipt",
                        "create"
                      ),
                    },
                    {
                      menuText: `Part Pick`,
                      data: data,
                      clickAction: this.showPartPickSalesOrder,
                      visible:
                        (FeatureStorage.checkPermission("SalesOrder", "read") ||
                          FeatureStorage.checkPermission(
                            "SalesOrder",
                            "create"
                          )) &&
                        (data.data.Status == "A" ||
                          data.data.Status == "P" ||
                          data.data.Status == "L"),
                      disabled: !FeatureStorage.checkPermission(
                        "SalesOrder",
                        "create"
                      ),
                    },
                    {
                      menuText: "Deposit Claim",
                      data: data,
                      clickAction: this.showDepositClaim,
                      visible:
                        (FeatureStorage.checkPermission(
                          "CashReceipt",
                          "read"
                        ) ||
                          FeatureStorage.checkPermission(
                            "CashReceipt",
                            "create"
                          )) &&
                        data.data.Status == "A",
                      disabled: false,
                    },
                    {
                      menuText: "Copy",
                      data: data,
                      clickAction: this.copySOFromList,
                    },
                    {
                      menuText: "Split Order",
                      data: data,
                      clickAction: this.openSplitOrder,
                      visible:
                        FeatureStorage.checkPermission("SalesOrder", "create") &&
                        (data.data.Status === "A" ||
                          data.data.Status === "P" ||
                          data.data.Status === "D"),
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: (data) => {
                if (!data) return true;
              },
            },
          ],
        },
      };

      return config;
    },
    getCustomerRepDefault() {
      if (this.CustomerSalesRepresentativeCode)
        return [this.CustomerSalesRepresentativeCode];
      else return false;
    },
  },
  methods: {
    payNowCallback(paymentCreated, salesOrderCode) {
      this.payNowPopupProps.visible = false;
      if (paymentCreated) {
        this.$notify(
          `Successfully created payment for SO ${salesOrderCode}`,
          "success"
        );

        this.$refs["sales-order-list"].$refs[
          "transactionListGrid"
        ].gridRepaint();
      }
    },
    partPickCallback() {
      this.partPickPopupProps.visible = false;
    },
    onChangeNewShipDate(e) {
      this.NewShipDate.Value = e.value;
    },
    async completeSalesOrder(data) {
      let payload = {
        SalesOrderCode: data.Code,
      };

      await SalesOrderService.completeSalesOrder(payload)
        .then(() => {
          this.$notify(`SO #${data.Code} has been completed.`, "success");

          this.$refs["sales-order-list"].$refs[
            "transactionListGrid"
          ].gridRepaint();
        })
        .catch((err) => {
          this.serverError = {
            err: err,
            msg: "Update Failed.",
            time: new Date().getTime(),
          };
          this.$notify(`SO #${data.Code} could not be completed.`, "error");
        });
    },
    showPayNowSalesOrder(data) {
      this.payNowPopupProps.visible = true;
      this.payNowPopupProps.salesOrderCode = data.Code;
      this.payNowPopupProps.customerCode = data.CustomerCode;
      this.payNowPopupProps.customerName = data.CustomerName;
      this.payNowPopupProps.orderAmount = data.FxTotal;
      this.payNowPopupProps.callback = this.payNowCallback;
    },
    showPartPickSalesOrder(data) {
      this.partPickPopupProps.visible = true;
      this.partPickPopupProps.salesOrderCode = data.Code;
      this.partPickPopupProps.customerCode = data.CustomerCode;
      this.partPickPopupProps.customerName = data.CustomerName;
      this.partPickPopupProps.shipDate = data.ShipDate;
      this.partPickPopupProps.requiredByDate = data.RequiredByDate;
      this.partPickPopupProps.callback = this.partPickCallback;
    },
    showDepositClaim(data) {
      this.depositClaimProps.visible = true;
      this.depositClaimProps.data = data;
      this.depositClaimProps.callback = (save) => {
        this.depositClaimProps.visible = false;
        if (save)
          this.$refs["sales-order-list"].$refs[
            "transactionListGrid"
          ].gridRepaint();
      };
    },
    async showAdjustShipDatePopup(data) {
      this.setLoading = true;

      this.adjustShipDateDataModel = {
        SalesOrder: `${data.Code}`,
        Customer: data.CustomerName,
        RequiredByDate: data.RequiredByDate,
        ShipDate: data.ShipDate,
        NewShipDate: data.ShipDate,
      };

      this.NewShipDate.Min = new Date();
      this.NewShipDate.Value = data.ShipDate;

      this.setLoading = false;
      this.gcPopupVisible = true;
    },
    async onGcPopUpUpdate(e) {
      this.adjustShipDateCallback();
      let payLoad = {
        SalesOrderCode: e.SalesOrder,
        ShipDate: e.NewShipDate,
        RequiredByDate: e.RequiredByDate,
      };

      await SalesOrderService.adjustShipDate(payLoad)
        .then((res) => {
          this.$notify(
            `SO #${res.data.SalesOrderCode} ship date has been updated.`,
            "success"
          );

          this.$refs["sales-order-list"].$refs[
            "transactionListGrid"
          ].gridRepaint();
        })
        .catch((err) => {
          this.serverError = {
            err: err,
            msg: "Update Failed.",
            time: new Date().getTime(),
          };
          this.$notify(
            `SO #${this.adjustShipDateDataModel.SalesOrder} failed to update`,
            "error"
          );
        });
    },
    adjustShipDateCallback() {
      this.gcPopupVisible = false;
    },
    async lockOrder(e, grid) {
      await DespatchOrderListService.lockOrder({
        Code: e.Code,
      })
        // eslint-disable-next-line no-unused-vars
        .then((result) => {
          this.showLoading(false);
          // this.$logger.debug("result ", result);
          grid.refresh(true);
        })
        .catch((error) => {
          this.displayServerError(error, "Order lock Failed");
        });
    },
    async unLockOrder(e, grid) {
      await DespatchOrderListService.unlockOrder({
        Code: e.Code,
      })
        // eslint-disable-next-line no-unused-vars
        .then((result) => {
          this.showLoading(false);
          // this.$logger.debug("result ", result);
          grid.refresh(true);
        })
        .catch((error) => {
          this.displayServerError(error, "Order unlock Failed");
        });
    },
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "OrderStatus" &&
        e.column.screenField != "GridRecordEmail" &&
        e.column.screenField != "GridRecordPDFView" &&
        e.column.screenField != "GridRecordPrint" &&
        e.column.screenField != "GridRecordDelete" &&
        e.column.screenField != "GridRecordEllipsisMenu"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: this.salesOrderRouteForRowClick,
          mode: "review",
          idProperty: "Code",
        });
      }
    },
    async setSalesOrderScreenNavigation() {
      await SettingsService.getBySettingName("SalesOrderVersionInUse").then(
        (res) => {
          logDev("setSalesOrderScreenNavigation data value", res.data.value);
          if (res.data.value.length > 0) {
            this.SalesOrderScreenVersion = res.data.value[0].SettingValue;
          }
        }
      );
    },
    async setDefaultCustomerRep() {
      var defaultSalesRep = CacheService.getCache(
        "UserDefaultSalesRepresentative"
      );

      if (!defaultSalesRep) {
        await SalesOrderListService.getUserDefaultSalesRepresentative()
          .then((result) => {
            this.setLoading = false;
            if (result.data.value[0].SalesRepresentativeCode != "") {
              this.CustomerSalesRepresentativeCode =
                result.data.value[0].SalesRepresentativeCode;
            }

            CacheService.saveCache(
              "UserDefaultSalesRepresentative",
              result.data.value[0],
              2
            );
            this.loaded = true;
          })
          .catch((err) => {
            logDev(
              "Error in SalesOrderListService.getUserDefaultSalesRepresentative",
              err
            );

            if (err) {
              this.setLoading = false;
              this.loaded = true;
            }
          });
      } else {
        if (defaultSalesRep.SalesRepresentativeCode != "")
          this.CustomerSalesRepresentativeCode =
            defaultSalesRep.SalesRepresentativeCode;

        this.loaded = true;
      }
    },
    copySOFromList(e) {
      this.$router.push({
        path: `/sales-order/create/${e.Code}`,
        query: {
          copy: true,
        },
      });
    },
    openSplitOrder(data) {
      this.splitOrderCode = data.Code;
      this.splitOrderVisible = true;
    },
    onSplitOrderSaved(newCode) {
      this.$notify(`Sales Order split successfully. New Sales Order ${newCode} created.`, "success");
      this.$refs["sales-order-list"].$refs["transactionListGrid"].gridRepaint();
    },
  },

  async created() {
    this.setLoading = true;
    await this.setSalesOrderScreenNavigation();
    await this.setDefaultCustomerRep();
  },
};
</script>

<style lang="scss"></style>
